import type { SVGProps } from 'react';

export function FillYoutubeIcon({
  width = 24,
  height = 24,
  stroke,
  fill,
}: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_29848_87890)">
        <path
          d="M0.000902006 11.9573C0.000902006 9.31614 0.000902006 6.6803 0.000902006 4.03913C0.000902006 1.64873 1.64357 0 4.02224 0C9.32357 0 14.6249 0 19.9262 0C22.3742 0 24.0009 1.63273 23.9956 4.07114C23.9956 9.37483 23.9956 14.6785 23.9956 19.9822C23.9956 22.3406 22.3476 24 19.9956 24C14.6782 24 9.36624 24 4.0489 24C1.6009 24 -0.0257647 22.3193 -0.00443133 19.8755C0.0222353 17.2343 0.000902006 14.5985 0.000902006 11.9573ZM12.0222 6.66963C10.3582 6.76567 8.6729 6.83504 6.9929 6.97377C5.51557 7.09649 4.90757 7.73677 4.76357 9.20409C4.58224 11.0449 4.5769 12.8911 4.76357 14.7319C4.9129 16.1992 5.45157 16.7755 6.90224 16.9622C9.1689 17.2557 11.4516 17.2557 13.7342 17.181C15.0089 17.1383 16.2836 17.0262 17.5529 16.8822C18.5076 16.7701 19.0782 16.1565 19.1902 15.2121C19.3129 14.1663 19.4249 13.1098 19.4142 12.064C19.3982 10.8688 19.2756 9.67363 19.1262 8.48911C19.0356 7.79013 18.5502 7.34727 17.8782 7.14451C17.5902 7.05914 17.2862 6.98444 16.9876 6.96309C15.3449 6.85638 13.7022 6.76567 12.0276 6.66963H12.0222Z"
          fill={fill}
        />
        <path
          d="M12.0221 6.66992C13.6915 6.76596 15.3395 6.85667 16.9821 6.96339C17.2808 6.98473 17.5795 7.05409 17.8728 7.1448C18.5448 7.34756 19.0301 7.79042 19.1208 8.4894C19.2701 9.67392 19.3928 10.8745 19.4088 12.0643C19.4248 13.1155 19.3128 14.1719 19.1848 15.2124C19.0728 16.1568 18.5021 16.7704 17.5475 16.8825C16.2781 17.0319 15.0035 17.1439 13.7288 17.1813C11.4515 17.2506 9.16879 17.2506 6.89679 16.9625C5.44612 16.7757 4.90746 16.2048 4.75812 14.7322C4.57146 12.8914 4.57679 11.0452 4.75812 9.20438C4.90212 7.73706 5.51012 7.09678 6.98746 6.97406C8.66746 6.83533 10.3528 6.76596 12.0168 6.66992H12.0221ZM14.3848 11.9736C13.0621 11.2159 11.8355 10.5116 10.5661 9.78064V14.1986C11.8515 13.4463 13.0835 12.7313 14.3848 11.9736Z"
          fill={stroke}
        />
        <path
          d="M14.3848 11.9742C13.0835 12.7319 11.8515 13.4522 10.5662 14.1992V9.78125C11.8355 10.5122 13.0622 11.2166 14.3848 11.9742Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_29848_87890">
          <rect width="24" height="24" fill="white" transform="translate(0.000732422)" />
        </clipPath>
      </defs>
    </svg>
  );
}
